import * as Sentry from '@sentry/react';
import api from 'api';
import store from 'store';

import { State } from 'store';
import IAsync from 'types/IAsync';
import IUserSummary from 'types/IUserSummary';

function setUsersAsync(usersAsync: IAsync<IUserSummary[]>) {
  store.setState((state: State) => ({
    dashboard: { ...state.dashboard, usersAsync },
  }));
}

export default function fetchDashboardUsers() {
  const usersAsync = store.getState().dashboard.usersAsync;

  switch (usersAsync.status) {
    case 'PENDING':
    case 'REFRESH':
      // Already fetching
      return;
    case 'INIT':
    case 'ERROR':
      setUsersAsync({ status: 'PENDING' });
      break;
    case 'SUCCESS':
      // Only fetch this once
      return;
  }

  api
    .get('dashboard/users')
    .json()
    .then(
      (data) => {
        setUsersAsync({
          status: 'SUCCESS',
          data: data as IUserSummary[],
        });
      },
      (error) => {
        Sentry.captureException(error);
        setUsersAsync({ status: 'ERROR' });
      },
    );
}
